module.exports = __webpack_public_path__ + "img/laptop-two.c657030e.png";